// data/languages/Cote/categories/famille.ts

import { CategoryData } from '../../../../types/types';

export const famille: CategoryData = {
    // Parents et Siblings
    'ⲉⲓⲱⲧ (eiôt)': {
        translation: 'Père',
        translationEn: 'Father',
        illustration: '👨'
    },
    'ⲙⲁⲁⲩ (maau)': {
        translation: 'Mère',
        translationEn: 'Mother',
        illustration: '👩'
    },
    'ⲥⲟⲛ (son)': {
        translation: 'Frère',
        translationEn: 'Brother',
        illustration: '👦'
    },
    'ⲥⲱⲛⲉ (sône)': {
        translation: 'Sœur',
        translationEn: 'Sister',
        illustration: '👧'
    },

    // Enfants et Descendance
    'ϣⲏⲣⲉ (šêre)': {
        translation: 'Fils',
        translationEn: 'Son',
        illustration: '👶'
    },
    'ϣⲉⲉⲣⲉ (šeere)': {
        translation: 'Fille',
        translationEn: 'Daughter',
        illustration: '👧'
    },
    'ⲁⲗⲟⲩ (alou)': {
        translation: 'Enfant / Garçon',
        translationEn: 'Child / Boy',
        illustration: '👶'
    },

    // Grands-parents
    'ⲉⲓⲱⲧ ⲛϩⲏⲧ (eiôt nhet)': {
        translation: 'Grand-père',
        translationEn: 'Grandfather',
        illustration: '👴'
    },
    'ⲙⲁⲁⲩ ⲛϩⲏⲧ (maau nhet)': {
        translation: 'Grand-mère',
        translationEn: 'Grandmother',
        illustration: '👵'
    },

    // Autres relations
    'ϩⲁⲓ (hai)': {
        translation: 'Époux / Mari',
        translationEn: 'Husband',
        illustration: '🤵'
    },
    'ⲥϩⲓⲙⲉ (shime)': {
        translation: 'Épouse / Femme',
        translationEn: 'Wife',
        illustration: '👰'
    },
    'ⲣⲱⲙⲉ (rôme)': {
        translation: 'Homme / Personne',
        translationEn: 'Man / Person',
        illustration: '👤'
    }
};

export default famille;
